<template>
  <div class="main-block">

    <SliderMenu></SliderMenu>

    <!-- Top of site, logo, username and device count -->
    <div class="header-block">
      <div class="main-logo">
        <img v-if="user.id && !user.medical_dashboard_logo_url" :src="require(`../assets/images/${logo}`)" height="70"
             alt="Icon">
        <img v-else-if="user.medical_dashboard_logo_url" :src="user.medical_dashboard_logo_url" height="70" alt="Icon">
      </div>
      <div><h1 class="main-title">{{ user.name }}</h1>
        <h3 class="sub-title">{{ $t('Active patients') }}: {{ activePatients.length }}</h3></div>
      <div></div>
    </div>

    <ActivePatients></ActivePatients>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import SliderMenu from './SliderMenu'
import ActivePatients from './ActivePatients'
import axios from 'axios'

export default {
  name: 'Main',

  sockets: {
    connect: function () {
      axios.get('/api/medical/subscribe').then(res => {
      })
    }
  },

  data() {
    return {
      componentLoaded: false,
      logo: process.env.VUE_APP_LOGO_IMAGE
    }
  },

  components: {
    ActivePatients,
    SliderMenu
  },

  computed: {
    ...mapState([
      'activePatients',
      'user'
    ])

  },

  async mounted() {
    const checkAuthResult = await axios.get('/api/checkAuth')
    if (checkAuthResult.data.state === 'forbidden') {
      this.$router.replace({name: 'Login'})
    } else if (checkAuthResult.data.state === 'ok' && checkAuthResult.data.data) {
      this.$store.commit('setUser', checkAuthResult.data.data)
    }

    this.$store.dispatch('loadActivePatients').then(() => {
      console.log('Active patients loaded:', this.activePatients)
    })

    this.componentLoaded = true

    setInterval(() => {
      axios.get('/api/medical/subscribe').then(res => {
      })
    }, 4.5 * 60 * 1000)

    this.$store.dispatch('loadDataTypes')
    this.$store.dispatch('loadDevices')
    // reload devices list each minute
    setInterval(() => {
      this.$store.dispatch('loadDevices')
    }, 60 * 1000)
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Main.vue